import React from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import LoginPage from './LoginPage';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return children;
};

export default ProtectedRoute; 